import axios from 'axios'

// axios.defaults.baseURL = 'http://120.52.32.96/'
axios.defaults.headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
}

axios.interceptors.request.use(
    config => {
        return config
    },
    res => {
        return res.data
    },
    error => {
        console.log('网络开了小差！请重试...')
        return Promise.reject(error)
    }
)
export default axios



// WEBPACK FOOTER //
// ./src/axios/index.js